import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";


import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';

import CheckIcon from "@mui/icons-material/Check";
import CodeIcon from '@mui/icons-material/Code';
import CommentIcon from "@mui/icons-material/Comment";
import DescriptionIcon from "@mui/icons-material/Description";
import EditButton from "@mui/icons-material/Edit";
import LinkIcon from "@mui/icons-material/Link";
import TodayIcon from "@mui/icons-material/Today";
import Visibility from "@mui/icons-material/Visibility";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiInstance from "../apiInterceptor";
import Schedule_Using_Date_Time_Frequency_2 from "./Schedule_Using_Date_Time_Frequency_2";


import Dialog from "@mui/material/Dialog";

import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import FilledInput from "@mui/material/FilledInput";
import FormControlLabel from "@mui/material/FormControlLabel";
import remove from "../Assets/images/icon/denied 1.gif";

import CodeDisplayModal from "../Components/CodeDisplayModal";
import useCodeEditorStore from "../store/codeEditorStore";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";

import axios from "axios";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { runScraperOnce } from "../Api/runScraperOnce";
import scheduling from "../Assets/images/icon/schedule_1.gif";
import AlertBox from "../Components/AlertBox";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { LoadingBtn } from "../Components/LoadingBtn";
import useHomeStore from "../store/homeStore";
import {
  cronToText,
  dataFormatter, dataFormatterOutputHistory, dateFormatter, fileName,
  formatDateString,
  formatFrequencyData,
  handleApiError, isLatestObjectCompleted, jsonFilePath, transformString
} from "../utils";
import Output_History_Table from "./Output_History_Table";



import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogHeader from "../Components/DialogHeader";


const Failed_Details_Page = ({ detailType, version, }) => {
  const session = JSON.parse(localStorage.getItem("session")) || null;
  const location = useLocation()
  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("session"))) {
      localStorage.setItem("pre-url", location.pathname)
      history.push("/signin");
    }
  }, [])
  const setHomeRowData = useHomeStore((state) => state.setRowData);
  const { urlid } = useParams();
  const history = useHistory();
  const pushVersion = version == "v2" ? "" : "v1/"
  // dropdown option
  // radio button

  const [open, setOpen] = useState(false);
  const [openLogspopup, setOpenLogspopup] = useState(false);
  const [openRemovepopup, setOpenRemovepopup] = useState(false);
  const [csure, setSure] = useState(false);
  const [usnOpen, setUsnOpen] = useState(false);



  const [enableState, setEnableState] = useState(false)
  const [cronexp, setCronExp] = useState("");
  const [openRescheduleconfirmation, setOpenRescheduleconfirmation] = useState(false);
  const cronRegex =
    /^((\*|([0-5]?\d)(-([0-5]?\d))?)(\/([0-5]?\d)?)?)\s+((\*|([01]?[0-9]|2[0-3])(-([01]?[0-9]|2[0-3]))?)(\/([01]?[0-9]|2[0-3]))?)\s+((\*|([0-2]?[0-9]|3[0-1])(-([0-2]?[0-9]|3[0-1]))?)(\/([0-2]?[0-9]|3[0-1]))?)\s+((\*|([1-9]|1[0-2])(-([1-9]|1[0-2]))?)(\/([1-9]|1[0-2]))?)\s+((\*|[0-7]|([0-7](,[0-7])+))(\-([0-7]))?)$/;


  const [update, setUpdate] = useState({});
  const [temp, setTemp] = useState("");


  const { handleOpenEditor } = useCodeEditorStore()

  const [StatusHistory,setStatusHistory] = useState("");
  const [SnapshotUrl,setSnapshotUrl] = useState();
  const [details, setDetails] = useState([]);
  const [outputHistoryData, setOutputHistory] = useState();
  const [fileData, setFileData] = useState({
    data: {},
    id: null,
  });

  const [files, setFiles] = useState([]);
  const [openRunOnce, setOpenRunOnce] = useState(false);

  const [activitylogs, setActivitylogs] = useState([]);
  const [openal, setOpenal] = React.useState(false);

  const handleClickOpenal = () => {
    if (activitylogs.length == 0) {
      toast.info("No activity logs found")
      return
    }
    setOpenal(true);
  };
  const handleCloseal = () => {
    setOpenal(false);
  };


  const [refresher, setRefresher] = useState(false);

  const [imageModal, setImageModal] = useState(false)
  const [currImage, setCurrImage] = useState("")

  // row data
  const [rowData, setRowData] = useState();
  // header row
  const rendercolDefs1 = useCallback((params) => {
    const isScrape = params.data.command === "scrape";
    const updateType = isScrape ? "prompt" : "comment";
    
    // Extract temp value logic
    const tempValue = isScrape
      ? params.data.prompts || "?"
      : params.data.comments || "-";
    
    // Extract content logic for update object
    const updateContent = isScrape
      ? params.data.prompt || "-"
      : params.data.comment || "-";
    
    return (
      <Box className="fx_pc">
        <Tooltip title={isScrape ? "Update Prompt" : "Update Comment"}>
          <IconButton
            className="iconbutton_comment"
            onClick={() => {
              setTemp(tempValue);
              setUpdate({
                step_id: `${params.data.seq}`,
                url_id: urlid,
                update_type: updateType,
                [updateType]: updateContent,
              });
              handleClickOpen();
            }}
          >
            {params.data.command === "scrape" ? null : params.data
              .command === "open" ? null : (
              <CommentIcon fontSize="small" className="comment_icon" />
            )}
          </IconButton>
        </Tooltip>
      </Box>         
    );
  }, []);

  const [colDefs] = useState([
    {
      headerName: "",
      field: "comments",
      value: "1",
      minWidth: 20,
      flex: 1,
      cellRenderer: rendercolDefs1,
    },

    { headerName: "Seq", field: "seq", minWidth: 60, flex: 1 },
    { headerName: "Command", field: "command", minWidth: 100, flex: 1 },

    { headerName: "XPath", field: "xpath", minWidth: 130, flex: 3 },
    {
      headerName: "Prompts",
      field: "prompts",
      minWidth: 250,
      flex: 2,
    },
    { headerName: "Comments", field: "comments", minWidth: 250, flex: 2 },
    // {
    //   field: "",
    //   value: "1",
    //   minWidth: 55,
    //   flex: 1,
    //   headerClass: "center-header",
    //   cellStyle: {
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //   },
    //   cellRenderer: (params) => (
    //    <>
    //     {(params.data.command != "open" && params.data.image != "-") &&  <IconButton
    //       onClick={() =>{
    //        setCurrImage(params.data.image)
    //        setImageModal(true)
    //       }
    //       }
    //     >
    //       <Image className="comment_icon" fontSize="small" />
    //     </IconButton>}
    //     </>
    //   ),
    // },
  ]);

  /* modal box1 */

  const handleClickOpen = () => {
    console.log(update);
    setOpen(true);
  };
  const [selectedOption, setSelectedOption] = useState("b");
  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [isDownloadingState, setDownloadingState] = useState(false)

  const handleClose = () => {
    let updation = { ...update };
    updation["prompt"] = temp;
    updateAPI(updation);

    setOpen(false);
    setTemp("");
    setSure(false);
    setUpdate({});
  };

  /* modal box2 */
  const handleCloseRescheduleconfirmation = () => {
    setOpenRescheduleconfirmation(false);
  };
  const handleClickOpenLogspopup = async (value) => {
    await fetchJSONAPI(value);
    setOpenLogspopup(true);
  };

  const handleCloseLogspopup = () => {
    setOpenLogspopup(false);

    setFileData({ data: {}, id: null });
    setSure(false);
  };
  const handleClickOpenRunOnce = () => {
    setOpenRunOnce(true);
  };
  const handleCloseRunOnce = () => {
    setOpenRunOnce(false);
  };

  const handleCloseUsn = () => {
    let updation = { ...update };
    updation["scrapper_name"] = temp;
    updateAPI(updation);

    setUsnOpen(false);
    setTemp("");
    setSure(false);
    setUpdate({});
  };

  useEffect(() => {
    if (outputHistoryData && outputHistoryData.some(data => data.status == "Scheduled" || data.status == "In_progress")) {
      setTimeout(() => {
        urlidAPI(detailType == "disabled" ? "disabled" : "not_working")
      }, 20000)
    }
  }, [outputHistoryData])

  const urlidAPI = async (status) => {

    const endp = `/${version}/get_url_data?url_id=${urlid}&status_type=${status}`;
    try {
      const response = await apiInstance.get(endp);

      if (response.statusText === "OK") {
        if (detailType == "disabled") {
          response.data.schedular_history = response.data.schedular_history.filter(data => data.progress_status == "completed" || data.progress_status == "failed")
        }
        setOutputHistory(

          dataFormatterOutputHistory(response.data.schedular_history)
        );
        setRowData(dataFormatter(response.data.xpath_master));
        setActivitylogs(response.data.activity_logs);
        response.data.transactions
          ? setFiles(jsonFilePath(response.data.transactions))
          : console.log("no transactions");
        setDetails(response.data);
      }
    } catch (e) {
      setRowData([]);
      console.log(e);
    }
  };

  useEffect(() => {
    urlidAPI(detailType == "disabled" ? "disabled" : "not_working");
  }, [urlid, refresher]);

  const fetchJSONAPI = async (value, flag) => {
    const url = `${version}/preview_json_data`;

    try {

      if (version == "v2") {
        const response = await apiInstance.post(url, {
          prj_id: `${details.project_code}`,
          json_bucket_file_path: value.path
        });

        if (response.statusText === "OK") {
          setFileData({ data: response.data.preview, id: value.id });
        }
      } else {
        const response = await axios.get(process.env.REACT_APP_BUCKET_URL + value.path);
        if (response.statusText === "OK") {
          setFileData({ data: response.data, id: value.id });
        }
      }

    } catch (e) {
      console.log(e);
    }
  };

  const extractLogsFromUrl = async (url) => {
    if (!url) return "No logs found";
    const response = await axios.get(url);
    const data = await response.data;
    return data;
  };


  const schedulerAPI = async (value) => {
    if (cronRegex.test(value)) {

      const urlcron = encodeURIComponent(value);

      const endp = `${version}/reschedule-task/?job_id=${details.job_id}&reschedule_by=${session.employeeCode}&new_cron_expression=${urlcron}`;

      try {
        const response = await apiInstance.post(endp, null);
        if (response.statusText === "OK") {

          toast.success(`Succesfully scheduled scraper for ${urlid}`);
          setTimeout(() => {

            history.push(`/${pushVersion}`);
          }, 2000);
        }
      } catch (e) {
        console.log(e);
        handleApiError(e)
      }
    }
  };

  const updateAPI = async (data) => {
    setUpdate((prev) => ({
      ...prev,
      prompt: temp,
    }));

    const endp = `${version}/update_prompt_comment_info`;

    try {
      const response = await apiInstance.patch(endp, data);
      console.log("PATCH request successful:", response.data);
    } catch (error) {
      handleApiError(error)
      console.error("Error sending PATCH request:", error);
    }
  };

  const removeAPI = async () => {
    const endp = `${version}/delete_scrapper`;
    const data = {
      url_id: urlid,
      emp_code: session.employeeCode,
      disable_flag: false,
    };
    try {
      const response = await apiInstance.patch(endp, data);
      console.log("PATCH request successful:", response.data);
      toast.success("Successfully removed scraper");

      setTimeout(() => {
        setHomeRowData([]);
        history.push(`/`, { status: "disabled" });
      }, 2000);
    } catch (error) {
      handleApiError(error)
      console.error("Error sending PATCH request:", error);
    }
  };


  const rowHeight = 24;
  const headerHeight = 28;




  const handleClickOpenOutputHistory = async (value, details1, type, setIsDownloading,status,snapshot_url) => {

    await fetchJSONOutputHistory(value, details1, type, setIsDownloading);
    setStatusHistory(status)
    setSnapshotUrl(snapshot_url)
    if (type.includes("pre")) setOpenLogspopup(true);
  };

  const handleDownload = (data, filename, type) => {
    if (version == "v2") {
      if (!data) {
        setDownloadingState(false)
        return;
      }
      const link = document.createElement('a');
      link.href = data;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        setDownloadingState(false)
      }, 1000);
      toast.success("Download started successfully")
      document.body.removeChild(link);
      return;
    }

    const jsonData = JSON.stringify(data);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  const fetchJSONOutputHistory = async (value, details1, type, setIsDownloading) => {
    const url = `${version}/preview_json_data`;

    try {

      if (version == "v2") {
        const response = await apiInstance.post(url, {
          prj_id: `${details1.project_code}`,
          json_bucket_file_path: value.json?.replace(process.env.REACT_APP_BUCKET_URL, ""),
          log_bucket_file_path: value.log?.replace(process.env.REACT_APP_BUCKET_URL, "")

        });
        let tempValue = value.json;
        if (type.includes("log")) {
          tempValue = value.log
        }


        if (response.statusText === "OK") {
          setIsDownloading(false)
          if (!tempValue) {
            tempValue = "none"
          }
          const parts = tempValue
            ?.replace(process.env.REACT_APP_BUCKET_URL, "")
            .split("/");
          const fileNameDownload = parts[parts.length - 1];
          if (type.includes("json")) {
            setFileData({
              data: response.data.preview,
              id: tempValue.id,
              type: type,
              fileName: fileNameDownload,
              presigned_url: response.data.json_presigned_url,
            });
          } else {
            const logContent = await extractLogsFromUrl(
              response.data.log_presigned_url
            );

            setFileData({
              data: logContent,
              id: tempValue.id,
              type: type,
              fileName: fileNameDownload,
              presigned_url: response.data.log_presigned_url,
            });
          }


          if (!type.includes("pre")) {
            const parts = tempValue?.replace(process.env.REACT_APP_BUCKET_URL, "").split('/');
            const fileNameDownload = parts[parts.length - 1];
            if (type == "logs") {
              handleDownload(response.data.log_presigned_url, fileNameDownload, type)
            } else {
              handleDownload(response.data.csv_presigned_url ? response.data.csv_presigned_url : response.data.json_presigned_url, fileNameDownload, type)
            }

          }
        }
      } else {
        let tempValue = value.json;
        if (type.includes("log")) {
          tempValue = value.log
        }
        const response = await apiInstance.get(tempValue);
        if (response.statusText === "OK") {
          setFileData({ data: response.data, id: tempValue.id });
          if (type != "") {
            const parts = tempValue.replace(process.env.REACT_APP_BUCKET_URL, "").split('/');

            const fileNameDownload = parts[parts.length - 1];

            if (type == "logs") {
              handleDownload(response.data, fileNameDownload, type)
            } else {
              handleDownload(response.data.preview, fileNameDownload, type)
            }
          }
        }
      }

    } catch (e) {
      console.log(e);
    }
  };
  function getMostRecentAddedOn(dataArray) {
    if (dataArray.length === 0) {
      return null;
    }

    let mostRecentDate = dataArray[0].added_on;
    for (let i = 1; i < dataArray.length; i++) {
      if (new Date(dataArray[i].added_on) > new Date(mostRecentDate)) {
        mostRecentDate = dataArray[i].added_on;
      }
    }
    return mostRecentDate;
  }

  const getScraperType = (details) => {
    if (
      details.urls_data &&
      details.urls_data.length > 0 &&
      details.scraper_type === "PAGINATION"
    ) {
      return transformString(
        `${details.scraper_type} > ${details.pagination_type} > ${details.data_source_type} > MULTI_URL`
      );
    }
  
    if (details.scraper_type === "PAGINATION") {
      return transformString(
        `${details.scraper_type} > ${details.pagination_type} > ${details.data_source_type}`
      );
    }
  
    if (
      details.urls_data &&
      details.urls_data.length > 0 &&
      details.scraper_type === "NO_PAGINATION"
    ) {
      return transformString("NO_PAGINATION > MULTI_URL");
    }
  
    if (details.file_download_flag) {
      return "File Download";
    }
  
    if (details.scraper_type) {
      return transformString(details.scraper_type);
    }
  
    return "";
  };  

  // header and row height
  const getActionChanges = (activity) => {
    if (activity.action_changes && activity.action_changes.new_changes) {
      if (['RE-SCHEDULE', 'SCHEDULE'].includes(activity.action_type)) {
        return typeof activity.action_changes.new_changes === 'string'
          ? cronToText(activity.action_changes.new_changes) + "."
          : formatFrequencyData(activity.action_changes.new_changes);
      }
      if (activity.action_type === 'RENAME_COLUMN') {
        return "";
      }
      if (activity.action_type === 'CODE_CHANGES') {
        return "";
      }
      return "New " + activity.action_msg + ": " + activity.action_changes.new_changes + ".";
    }
    return "";
  };

  return (
    <>
      <Header />
      <Box id="page-container">
        <Container maxWidth>
          <Grid container spacing={1} mb={1} justifyContent="center">
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box className="fx_sb_mob">
                <Box>
                  <Typography variant="h4" className="col1 fw5 ">
                    {detailType == "disabled"
                      ? "Disabled Scraper Details"
                      : "Failed Scraper Details"}
                  </Typography>
                </Box>
                <Box className="fx_fs margin_10">
                  <Box mr={2}>
                    <Button
                      className="approve_btn"
                      onClick={() => {

                        history.push(`/`);
                      }}
                    >
                      Back
                    </Button>
                  </Box>
                  <Box mr={2}>
                    <Button
                      className="approve_btn"
                      onClick={() => {
                        setOpenRemovepopup(true);
                      }}
                    >
                      Remove
                    </Button>
                  </Box>
                  <Box>
                    <Button className="approve_btn" onClick={handleClickOpenal}>
                      Activity Logs
                    </Button>
                  </Box>
                  {(detailType == "disabled" || detailType == "failed") && (<Box ml={2}>
                    <Button
                      className="Enable_btn"
                      disabled={enableState}
                      onClick={() => {
                        if ((files.some((file) => file.status == "approved") &&
                          isLatestObjectCompleted(outputHistoryData)) || detailType == "disabled") {
                          setEnableState(true)
                        } else {
                          toast.info("Latest Transaction should be completed, Run Scapper once")
                        }

                      }}
                    >
                      Enable
                    </Button>
                  </Box>)}
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid container justifyContent="center" spacing={1}>
            <Grid item lg={2.4} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className={`iconbx iconbx_2 ${detailType == "disabled" ? "cbg4" : "cbg3"}`}>
                  <IconButton
                    disableRipple
                    onClick={() => {
                      window.open(details.website_url, "_blank");
                    }}
                  >
                    <LinkIcon fontSize="small" className="wh card_icon4" />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      {urlid}
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                      title={details.website_url ? details.website_url : "-"}
                    >
                      {details.website_url ? details.website_url : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>
            <Grid item lg={2.4} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className={`iconbx iconbx_2 ${detailType == "disabled" ? "cbg4" : "cbg3"}`}>
                  <IconButton
                    disableRipple
                    onClick={() => {
                      setTemp(
                        details.scraper_name ? details.scraper_name : "-"
                      );
                      setSure(false);
                      setUpdate({
                        url_id: urlid,
                        update_type: "scrapper_name",
                        scrapper_name: details.scraper_name
                          ? details.scraper_name
                          : "-",
                      });
                      setUsnOpen(true);
                    }}
                  >
                    <EditButton
                      fontSize="large"
                      className="wh card_icon4"
                    />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Scraper Name{" "}
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {details.scraper_name ? details.scraper_name : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            <Grid item lg={2.4} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className={`iconbx iconbx_2 ${detailType == "disabled" ? "cbg4" : "cbg3"}`}>
                  <IconButton disableRipple disabled>
                    <DescriptionIcon
                      fontSize="large"
                      className="wh card_icon4"
                    />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Scraper Type
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {getScraperType(details)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            <Grid item lg={2.4} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb">
                <Box className={`iconbx iconbx_2 ${detailType == "disabled" ? "cbg4" : "cbg3"}`}>
                  <IconButton disableRipple disabled>
                    <TodayIcon fontSize="large" className="wh card_icon4" />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Scheduled On
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {details.schedular_history
                        ? dateFormatter(getMostRecentAddedOn(details.schedular_history))
                        : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            <Grid item lg={2.4} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb">
                <Box className={`iconbx iconbx_2 ${detailType == "disabled" ? "cbg4" : "cbg3"}`}>
                  <IconButton disableRipple disabled>
                    <TodayIcon fontSize="large" className="wh card_icon4" />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      {detailType == "disabled" ? "Disabled On" : "Failed On"}
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {detailType == "disabled"
                        ? details.disabled_on
                          ? dateFormatter(details.disabled_on)
                          : "-"
                        : details.failed_on
                          ? dateFormatter(details.failed_on)
                          : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>
          </Grid>

          <Grid container justifyContent="center" spacing={1}>
            <Grid item lg={7} md={7} sm={12} xs={12}>
              <Box className="whitebx" mt={1}>
                <Box className="fx_sb ai_end heading_bx">
                  <Box>
                    <Typography variant="h6" className=" col1 card_title ">
                      Scrapping Commands
                    </Typography>
                  </Box>
                </Box>
                <Box
                  className={"ag-theme-quartz  "}
                  style={{ width: "100%", height: "173px" }}
                >
                  <AgGridReact
                    rowData={rowData}
                    columnDefs={colDefs}
                    rowHeight={rowHeight}
                    headerHeight={headerHeight}
                    filter={true}
                    enableCellTextSelection={true}
                  />
                </Box>
              </Box>

              <Box className="whitebx" mt={1} style={{ height: '240px' }}>
                <Output_History_Table
                  response_data={outputHistoryData}
                  on_preview={handleClickOpenOutputHistory}
                  on_download={handleClickOpenOutputHistory}
                  details={details}
                />
                {(version == "v2" && detailType == "failed") &&
                  <Box mt={2} className="al_right">
                    <Button onClick={() => handleClickOpenRunOnce()} className="run_scraper_btn">  Run Scraper   </Button>
                  </Box>
                }
              </Box>
            </Grid>

            <Grid item lg={5} md={5} sm={12} xs={12}>
              <Grid container justifyContent="center" spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box className="whitebx" mt={1}>
                    <Box className="heading_bx">
                      <Typography variant="h6" className=" col1 card_title ">
                        Data Preview
                      </Typography>
                    </Box>

                    <Box className="preview_mainbx">
                      {files.map((file, index) =>
                        file.id ? (
                          <Box key={file.id || index} className="preview_bx al_center " p={1}>
                            <Box>
                              <Typography variant="h6" className="one bl xstext  ">
                                {"File Name:"}
                              </Typography>
                              <Typography variant="h6" className="card_preview_heading bl xstext  ">
                                {file.status === "approved" || file.status === "completed"
                                  ? fileName(file.path)
                                  : "Preview In Pending"}
                              </Typography>
                            </Box>
                            <Box mt={2}>
                              <Tooltip title={file.path ? (file.status === "approved" ? "Approved" : "Approve") : null} arrow>
                                <IconButton style={{ backgroundColor: file.status === "approved" ? "green" : "#1930ab" }} disabled={true}>
                                  {file.loader ? (
                                    <CircularProgress size={12} style={{ color: "white" }} />
                                  ) : (
                                    <CheckIcon className="approve_icon" style={{ color: "white" }} />
                                  )}
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Preview" arrow>
                                <IconButton onClick={() => handleClickOpenLogspopup(file)} disabled={file.path ? false : true} className="eye_btn">
                                  <Visibility fontSize="medium" className="wh approve_icon" />
                                </IconButton>
                              </Tooltip>
                              {localStorage.getItem("techLead") === "true" && (
                                <Tooltip
                                  style={{
                                    display: file.status !== "approved" && file.status !== "completed" ? "none" : "inline-flex",
                                  }}
                                  title="Code"
                                  arrow
                                >
                                  <IconButton
                                    onClick={() => { handleOpenEditor(file, details) }}
                                    disabled={file.path ? (file.status !== "approved" && file.status !== "completed") : true}
                                    className="eye_btn"
                                  >
                                    <CodeIcon fontSize="medium" className="wh approve_icon" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </Box>
                          </Box>
                        ) : null
                      )}
                    </Box>

                  </Box>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  {enableState ? (<Box className="whitebx2 schedule relative">
                    <Box className="heading_bx fx_sb_mob">
                      <Box className="">
                        <Typography variant="h6" className=" col1 card_title ">
                          Schedule
                        </Typography>
                      </Box>

                      <Box>
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={selectedOption}
                            onChange={handleRadioChange}
                          >
                            <FormControlLabel
                              value="b"
                              control={<Radio />}
                              label="Using Date, Time & Frequency"
                            />
                            <FormControlLabel
                              value="a"
                              control={<Radio />}
                              label="Using Cron Expression"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Box>

                    {
                      selectedOption === "a" ? (
                        <Box className="cron_expression" my={2}>
                          <Grid container justifyContent="center" spacing={1}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <FormControl fullWidth className="input_field">
                                <FilledInput
                                  className="textfield_cron"
                                  id="filled-adornment-password"
                                  placeholder="Enter Cron Expression"
                                  onChange={(event) => {
                                    setCronExp(event.target.value);
                                  }}
                                />
                              </FormControl>
                              <Box mt={1} className="al_left">
                                <Typography variant="h6" className="gray desc">
                                  {" "}
                                  Note: A cron expression is a string
                                  representing a schedule in a time-based job
                                  scheduling system (like Unix cron). It is
                                  typically made up of five or six fields,
                                  separated by space, that represent different
                                  units of time.
                                </Typography>

                                <Typography
                                  variant="h6"
                                  className="xstext"
                                  mt={1}
                                >
                                  {" "}
                                  Example: A cron expression 0 12 * * Mon means
                                  the task will run at 12:00 PM every Monday.
                                  Learn more{" "}
                                  <a
                                    href="https://crontab.guru/"
                                    className="a_underline"
                                    target="_blank"
                                  >
                                    click here
                                  </a>
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>

                          <Box className="bottom-fixed-stack">
                            <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent="flex-end">
                              <Button
                                className="approve_btn"
                                disabled={!cronRegex.test(cronexp)}
                                onClick={() => {
                                  setOpenRescheduleconfirmation(true);
                                }}
                              >
                                Re-schedule
                              </Button>

                              <Button
                                className="cancel_btn"
                                onClick={() => { setEnableState(false) }}
                              >
                                Cancel
                              </Button>
                            </Stack>
                          </Box>

                        </Box>
                      ) : (
                        <Schedule_Using_Date_Time_Frequency_2
                          urlid={urlid}
                          schedule_flag={true}
                          emp_code={session.employeeCode}
                          job_id={details.job_id ? details.job_id : null}
                          reschedule_flag={true}
                          version={version}
                          allowed={detailType == "disabled" ||
                            (files.some((file) => file.status == "approved") &&
                              isLatestObjectCompleted(outputHistoryData))
                          }
                          cancelEnable={() => { setEnableState(false) }}
                          pageType="failed"
                        />
                      )
                    }
                  </Box>) : (
                    <Box className="whitebx2 schedule">
                      <Box className="heading_bx fx_sb_mob  ">
                        <Box className="">
                          <Typography variant="h6" className=" col1 card_title ">
                            {detailType == "disabled"
                              ? "Disabled Reason"
                              : "Exceptions"}
                          </Typography>
                        </Box>
                      </Box>
                      <Box style={{ width: "100%" }}>
                        {detailType == "disabled" ? (
                          <AlertBox
                            title={""}
                            text={
                              details.disable_reason
                                ? details.disable_reason
                                : '-'
                            }
                          />
                        ) : (
                          <AlertBox
                            text={
                              details.exceptions
                                ? JSON.stringify(
                                  details.exceptions.error_msg,
                                  null,
                                  2
                                )
                                : details.schedular_history ? (details.schedular_history.length > 0 && details.schedular_history[0].error_msg) ? `${details.schedular_history[0].error_msg.slice(0, 600)}...` : '-' : '-'
                            }
                          />
                        )}
                      </Box>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Schedule cron exp */}
      <Box className="data preview">
        <Dialog
          open={openRescheduleconfirmation}
          onClose={handleCloseRescheduleconfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Schedule"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to re-schedule?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={() => {
                  schedulerAPI(cronexp);
                }}
                autoFocus
                className="approve_btn"
              >
                Re-schedule
              </Button>
            </Box>
            <Box>
              <Button onClick={handleCloseRescheduleconfirmation} autoFocus className="cancel_btn">
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>

      {/* remove alert dialog */}

      <Box className="data preview">
        <Dialog
          open={openRemovepopup}
          onClose={() => {
            setOpenRemovepopup(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={remove}
                      alt="remove"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to remove?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={() => {
                  removeAPI();
                  setOpenRemovepopup(false);
                }}
                autoFocus
                className="approve_btn"
              >
                Ok
              </Button>
            </Box>
            <Box>
              <Button
                onClick={() => {
                  setOpenRemovepopup(false);
                }}
                autoFocus
                className="cancel_btn"
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>

      {/* modal box1 */}

      <Box className="comment">
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogHeader
            heading={update.update_type == "prompt" ? "Prompts :" : "Comments :"}
            onClose={() => {
              setOpen(false);
            }}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area">
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    name="message"
                    placeholder="Prompts information"
                    fullWidth
                    value={temp}
                    onChange={(event) => setTemp(event.target.value)}
                  />
                </Box>
              </Box>

              <Box py={1}>
                <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent="space-between">
                  <Box className="checkbox">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Are you sure"
                          checked={csure}
                          onChange={() => {
                            setSure(!csure);
                          }}
                          size="small"
                        />
                      }
                      label={
                        <span style={{ fontSize: "12px" }}>
                          Are you sure you want to update changes?
                        </span>
                      }
                    />
                  </Box>
                  <Box>
                    <Button
                      onClick={() => {

                        handleClose();
                      }}
                      autoFocus
                      className="approve_btn"
                      disabled={!csure}
                    >
                      Save
                    </Button>
                  </Box>
                </Stack>
              </Box>

            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>
      {/* Run Once Modal */}
      <Box className="data preview">
        <Dialog
          open={openRunOnce}
          onClose={handleCloseRunOnce}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Re-Schedule"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to run scraper once ?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={async () => {
                  await runScraperOnce(urlid, session.employeeCode, version)
                  setOpenRunOnce(false)
                  urlidAPI(detailType == "disabled" ? "disabled" : "not_working");
                }}
                autoFocus
                className="approve_btn"
              >
                Run Once
              </Button>
            </Box>
            <Box>
              <Button onClick={handleCloseRunOnce} autoFocus className="cancel_btn">
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
      {/* activity log */}

        <Dialog
          onClose={handleCloseal}
          aria-labelledby="customized-dialog-title"
          open={openal}
          maxWidth="xs"
          fullWidth
        >
          <DialogHeader
            heading="Activity Logs"
            onClose={handleCloseal}
          />
          <DialogContent className="history_drawer">
            <Box mb={2}>
              <List>
                {activitylogs.map((activity, index) => (
                  <>
                    <ListItem key={index} disablePadding>
                      <ListItemAvatar>
                        <Avatar style={{ backgroundColor: "#00b0f0" }}>
                          <QueryBuilderIcon fontSize="small" /> {/* You can replace ImageIcon with the desired icon */}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                            <Tooltip arrow title={<>
                              {(activity.action_by_emp_id === session.employeeCode ? "You" : activity.action_by)}{" "}
                              <strong>
                                {activity.action_type === "RENAME_COLUMN" ? (
                                  <>
                                    {"updated output preview keys"}
                                    <br />
                                    <br />
                                    <span style={{ marginTop: '3px' }}>
                                      {`Updated headers:  ${activity.action_changes ? JSON.stringify(activity.action_changes.new_changes) : '-'
                                        }`}
                                    </span>
                                  </>
                                ) : (
                                  activity.action_msg
                                )}
                              </strong>
                              {"."}
                              {getActionChanges(activity)}
                            </>}>
                              <Typography variant='h6' className='bl xtext lg2 fw4 one'>
                                {(activity.action_by_emp_id === session.employeeCode ? "You" : activity.action_by)}{" "}
                                <strong>
                                  {activity.action_type === "RENAME_COLUMN" ? (
                                    <>
                                      {"updated output preview keys"}
                                      <br />
                                      <br />
                                      <span style={{ marginTop: '3px' }}>
                                        {`Updated headers:  ${activity.action_changes ? JSON.stringify(activity.action_changes.new_changes) : '-'
                                          }`}
                                      </span>
                                    </>
                                  ) : (
                                    activity.action_msg
                                  )}
                                </strong>
                                {"."}
                                {getActionChanges(activity)}
                              </Typography>
                            </Tooltip>
                        }
                        secondary={
                            <Typography variant='h6' className='bl xtext lg fw4'>
                              {activity.action_on.includes('T') ? dateFormatter(activity.action_on) : formatDateString(activity.action_on)}
                            </Typography>
                        }
                      />
                    </ListItem>
                    <Box py={'4px'}>
                      <Divider />
                    </Box>
                  </>
                ))}
              </List>


            </Box>
          </DialogContent>
        </Dialog>
      {/* modal box2 */}

      <Box className="data preview">
        <Dialog
          open={openLogspopup}
          onClose={handleCloseLogspopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogHeader
            heading={fileData.type && fileData.type.includes("logs") ? "Logs" : "Data Preview"}
            onClose={() => {
              setOpenLogspopup(false);
            }}
          />


          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area">
                <Box className="input_field" pb={1}>
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    minRows={2}
                    maxRows={8}
                    name="message"
                    fullWidth
                    value={fileData.type && fileData.type.includes("logs")
                      ? fileData.data
                      : JSON.stringify(fileData.data, null, 2)}
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {fileData.presigned_url != undefined && (
                    <Box className="al_right" py={1} display="flex" flexDirection="row" justifyContent="flex-end" gap={2}>
                    {fileData.type.includes("logs") &&  
                    StatusHistory === "Failed" && SnapshotUrl && (
                        <Box>
                        <Button
                          onClick={() =>{
                            setCurrImage(SnapshotUrl)
                            setImageModal(true)
                          } 
                        }
                          className="approve_btn"
                        >
                          Check Snapshot
                        </Button>
                      </Box>)}
                    <Box>
                      {isDownloadingState ? <LoadingBtn /> :
                        <Button
                          autoFocus
                          className="approve_btn"
                          onClick={() => {
                            setDownloadingState(true)
                            handleDownload(fileData.presigned_url, fileData.fileName, fileData.type)
                          }}
                        >
                          Download
                        </Button>
                      }
                    </Box>
                    </Box>
                  )}
              </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>


      <Box className="data preview">
        <Dialog
          open={imageModal}
          onClose={() => {
            setImageModal(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              width: '1200px', // Set the desired width here
              height: '600px', // Set the desired height here (80% of the viewport height)
              maxWidth: 'none', // Ensures that maxWidth isn't limited by the `maxWidth` prop
            },
          }}

        >


          <DialogHeader
            onClose={() => {
              setImageModal(false);
            }}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>

                  <img
                    src={currImage}
                    alt="preview"

                    style={{
                      width: '100%',    // Ensure the image takes up the full width
                      height: 'auto',    // Ensure the image takes up the full height

                    }}
                  />

                </Box>

              </Box>
            </DialogContentText>
          </DialogContent>

        </Dialog>
      </Box>

      <CodeDisplayModal />
      {/* update scraper name modal */}
      <Box className="data preview">
        <Dialog
          open={usnOpen}
          onClose={() => setUsnOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogHeader
            heading="New Scraper Name :"
            onClose={() => {
              setUsnOpen(false);
            }}
          />


          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area">
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    minRows={2}
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={temp}
                    onChange={(event) => setTemp(event.target.value)}
                  />
                </Box>
                <Box py={1}>
                  <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent="space-between">
                    <Box className="checkbox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="Are you sure"
                            checked={csure}
                            onChange={() => {
                              setSure(!csure);
                            }}
                            size="10px"
                          />
                        }
                        label={
                          <span style={{ fontSize: "12px" }}>
                            Are you sure you want to update changes?
                          </span>
                        }
                      />
                    </Box>
                    <Box>
                      <Button
                        onClick={() => {

                          handleCloseUsn();
                          setRefresher(!refresher);
                        }}
                        autoFocus
                        className="approve_btn"
                        disabled={!csure}
                      >
                        Update
                      </Button>
                    </Box>
                  </Stack>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>
      <ToastContainer
        position="top-center"
        style={{ fontSize: "16px", width: "600px", height: "200px" }}
      />
      <Footer />
    </>
  );
};

export default Failed_Details_Page;